import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

import * as mappingEntry from './mapping-entry'

export const TRANSFORMER = graphql.transformers.IN.object<
  ents.extra.rate.gl.Mapping,
  graphql.schema.RateMappingInput
>({
  adjustmentLabel: transformers.PASS_THROUGH,
  entries: graphql.transformers.IN.default(
    graphql.transformers.IN.list(mappingEntry.TRANSFORMER, {
      onNullish: 'remove',
    }),
    [],
  ),
})
